module.exports = __webpack_public_path__ + "img/dfod-badge.fe42bd73.svg";